var prodcat = prodcat || {};

prodcat.data = prodcat.data || {};

(function ($) {
  Drupal.behaviors.shadePickerV3 = {
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;
      var $template = $('.js-shade-picker-shades-drawer', context);

      // Only fire on js-shade-picker-shades-drawer which is shade-picker-v3 for filtering.
      // We refer to shared classes below but that is OK inside this template.
      $template.each(function () {
        var $shadeGrid = $template.find('.js-spp-shades-grid');
        var $shadeLink = $shadeGrid.find('.js-spp-shades-grid-item');

        if ($shadeGrid.length && $shadeGrid.hasClass('js-spp-shades-grid--has-filters')) {
          $shadeLink.each(function () {
            var $this = $(this);
            var shadeFam = $this.data('color-family').trim().toLowerCase().replace(/\s+/g, '-');
            var skuBaseId = $this.data('skuBaseId');
            var skuDataL2 = prodcat.data.getSku(skuBaseId);

            if (skuDataL2 && skuDataL2.INVENTORY_STATUS) {
              var invStatus = skuDataL2.INVENTORY_STATUS;

              $this.addClass('shade-inv-status--' + invStatus);
            }

            if (shadeFam.length) {
              $this.addClass('swatch-colorfamily--' + shadeFam);
            }
          });

          // Initialize the filter
          $shadeGrid.mixItUp({
            animation: {
              animateResizeTargets: true
            },
            selectors: {
              target: '.js-spp-shades__grid-item--filterable',
              filter: '.js-product-full-filter'
            }
          });
        }
      });
      $(document).on('product.updateInvStatusFinished', function () {
        var $template = $('.js-shade-picker-shades-drawer', context);

        $template.each(function () {
          var $shadeGrid = $template.find('.js-spp-shades-grid');
          var items = $shadeGrid.find("[class^='shade-inv-status--'], [class*='shade-inv-status--']");

          if ($shadeGrid.length && $shadeGrid.hasClass('js-spp-shades-grid--has-filters')) {
            items.each(function () {
              var $this = $(this);
              var skuBaseId = $this.data('skuBaseId');
              var skuDataL2 = prodcat.data.getSku(skuBaseId);
              var invStatus;
              var shade_class = $this.attr('class');

              // Search if exist similar class to shade-inv-status-- and remove it to put the new one updated
              if (shade_class.indexOf('shade-inv-status--') >= 0) {
                var currentInvStatusClass = shade_class.match(/[\w-]*shade-inv-status--[\w-]*/g);

                $.each(currentInvStatusClass, function (i, element) {
                  $this.removeClass(element);
                });
              }
              if (skuDataL2 && skuDataL2.INVENTORY_STATUS) {
                invStatus = skuDataL2.INVENTORY_STATUS;
                $this.addClass('shade-inv-status--' + invStatus);
              }
            });
          }
        });
      });
    },
    attached: false
  };
})(jQuery);
